<p-dialog header="Header" [(visible)]="showDisclaimerDialog" [style]="{width: '440px'}" [modal]="true" [closable]="false">
  <ng-template pTemplate="header" class="bg-primary">
    <div class="m-2 text-white"><div class="mx-3">Disclaimer</div></div>
  </ng-template>
  <div class="m-4">
    While care has been taken to ensure that the information contained in Data On Demand, is accurate, Tata Steel IJmuiden B.V. nor its subsidiaries accept responsibility or liability for errors or information which is found to be misleading.
  </div>
  <ng-template pTemplate="footer">
    <div class="m-4">
      <p-button styleClass="px-3 py-2 w-100" (click)="closeDisclaimerDialog()" label="I agree" pAutoFocus [autofocus]="true"></p-button>
    </div>
  </ng-template>
</p-dialog>